import { GalleryList } from './gallery'

class BriefGalleryList extends GalleryList {
    getEntityKey() {
        return "customer/brief_gallery"
    }
}

export const briefGalleryList = new BriefGalleryList("brief_gallery_default")
export const briefGalleryListForEventTab = new BriefGalleryList("brief_gallery_list_for_event_tab_default")
export const briefGalleryListForPhotoArtTab = new BriefGalleryList("brief_gallery_list_for_photo_art_tab_default")
